export default function DeleteChecklistTemplateDialogCtrl($mdDialog, data) {
    "ngInject";

    var vm = this;
    var workflowUsages = data.workflowUsages || [];

    vm.model = {
        errorMessage: data.errorMessage,
        numActivitiesWhereQAIsUsed: data.numActivitiesWhereQAIsUsed,
        workflows: _groupActivitiesUnderProcessTemplate(workflowUsages),
    };

    vm.closeDialog = closeDialog;

    function closeDialog() {
        $mdDialog.cancel();
    }

    function _groupActivitiesUnderProcessTemplate(workflowUsages) {
        return Object.values(
            workflowUsages.reduce((acc, workflow) => {
                const processTemplateId = workflow.processTemplateId;

                if (!acc[processTemplateId]) {
                    acc[processTemplateId] = {
                        processTemplateId: workflow.processTemplateId,
                        processTemplateName: workflow.processTemplateName,
                        activities: [],
                    };
                }

                acc[processTemplateId].activities.push({
                    activityTemplateId: workflow.activityTemplateId,
                    activityTemplateName: workflow.activityTemplateName,
                });

                return acc;
            }, {})
        );
    }
}
